export default "__VITE_ASSET__DznIaJMj__"